import { useNavigate, useParams } from 'react-router-dom';
import { chkPin } from '@/api/server/common/auth';
import ArrowLinkButton from '@/component/common/arrow-link-button';
import RandomKeypad from '@/component/common/random-keypad';
import SecretNumberDisplay from '@/component/common/secret-number-display';
import SFStepper from '@/component/common/sf-stepper';
import TopBackButton from '@/component/common/top-back-button';
import { SFPalette } from '@/lib/color';
import { localGetStorage } from '@/lib/storage';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { toast } from 'react-toastify';
import ErrorRes from '@/api/server/ErrorRes';
import SendMailDrawer from '@/component/auth/send-mail-drawer';
import { usePinInfoActions } from '@/store/zustand/store';

export default function PinCheck() {
  const navigate = useNavigate();
  const { setPinInfo } = usePinInfoActions();
  const [secretNumber, setSecretNumber] = useState('');
  const [openSendMailDrawer, setOpenSendMailDrawer] = useState(false);
  const temp = localGetStorage('login');
  const { path = '/pinSetting' } = useParams();
  console.log(path);
  if (!temp) {
    navigate(-1);
    return;
  }
  const email = temp.email;
  const success = async () => {
    const res = await chkPin(secretNumber);
    if (res.ret_code !== 200) {
      ErrorRes({ code: res.ret_code, msg: res.msg, path: 'pinCheck', isBack: false });
      setSecretNumber('');
      return;
    }
    const url = path === '/pinSetting' ? '/pinSetting' : `/${path}`;
    // 현재 핀번호 저장
    const payload = {
      pinNum: secretNumber,
      path: url,
      active: true,
    };
    setPinInfo(payload);
    navigate(url);
  };
  return (
    <Container maxWidth="sm">
      <TopBackButton title="PIN 번호 확인" />
      <Box pt={4}>
        <Typography variant="h4" mb={2.5}>
          현재 사용 중인&nbsp;
          <b>
            PIN번호 <br />
            6자리
          </b>
          를 입력해 주세요.
        </Typography>
        <Box mb={5}>
          <ArrowLinkButton
            onClick={() => {
              setOpenSendMailDrawer(true);
            }}
          >
            혹시 PIN 번호를 잊어버리셨나요?
          </ArrowLinkButton>
        </Box>

        <Box mb={5}>
          <SecretNumberDisplay value={secretNumber} />
        </Box>
        {/* <Box position="absolute" bottom={0} left={0} mb={2}> */}
        <Box position="sticky" bottom={0}>
          <RandomKeypad
            value={secretNumber}
            onChange={setSecretNumber}
            onSuccess={async () => {
              await success();
            }}
          />
          {/* <Box mt={4.25} textAlign="center" pb={5}>
            <ArrowLinkButton onClick={() => {}}>
              다른 방법으로 로그인 하기
            </ArrowLinkButton>
          </Box> */}
        </Box>
      </Box>
      {/* </Box> */}
      <SendMailDrawer
        open={openSendMailDrawer}
        email={email}
        password={secretNumber}
        type="pin"
        onClose={() => setOpenSendMailDrawer(false)}
      />
    </Container>
  );
}
